export default __webpack_public_path__ + "static/media/Wolf's Boots of Woven Clouds.9e9f8a68.jpg";